





















































import Vue from 'vue'

import RowAddContentMenu from '../menus/RowAddContentMenu.vue'

export default Vue.extend({
  props: {
    canMoveUp: {
      type: Boolean,
      required: true
    },
    canMoveDown: {
      type: Boolean,
      required: true
    }
  },
  components: {
    RowAddContentMenu
  },
  methods: {
    startEditing() {
      this.$emit('row-start-editing')
    },
    confirmDelete() {
      if (!window.confirm('Soll diese Zeile (mit allen Inhalten) wirklich gelöscht werden?')) {
        return
      }
      this.$emit('row-remove')
    },
    moveUp() {
      if (!this.canMoveUp) {
        return
      }
      this.$emit('row-move-up')
    },
    moveDown() {
      if (!this.canMoveDown) {
        return
      }
      this.$emit('row-move-down')
    },
    onAddRow(insertBefore) {
      this.$emit('row-add-new', insertBefore)
    },
    onAddNewWidget(widgetType) {
      this.$emit('widget-add-new', widgetType)
    }
  }
})
